import { responsive } from '@/utils';

/**
 * Shared geometry and motion for overlay controls on the video surface. Kept in a leaf
 * module so both the widget stylesheet and the nested control stylesheets can use it.
 */

/** Distance from the right widget edge for pause, rewind, and the side rail. */
export const controlsRightInset = responsive.spacing['3xlarge'];

/** Distance from the bottom widget edge for pause and rewind. */
export const controlsBottomInset = responsive.spacing['3xlarge'];

/** One duration/easing for anything that fades in on hover or pointer activity. */
export const controlsFadeTransition = '0.25s ease-in-out';
